function parseBase64JsonObject(base64String, defaultValue = null) {
  if (!base64String || typeof base64String !== 'string') {
    return defaultValue;
  }

  try {
    const jsonString = window.atob(base64String);
    const parsedObject = JSON.parse(jsonString);

    return parsedObject;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(
      'parseBase64JsonObject: Failed to decode Base64 or parse JSON string.',
      {
        error,
      },
    );

    return defaultValue;
  }
}

export default parseBase64JsonObject;
